var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", attrs: { id: "cards" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [
                      _vm.metrics &&
                      _vm.metrics.length > 0 &&
                      _vm.activeAccount === null
                        ? _c("CostsMetricsGraph", {
                            key: _vm.id,
                            attrs: {
                              metrics: _vm.metrics,
                              name: _vm.CostsMetrics,
                              id: _vm.id,
                              activeType: _vm.activeType
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [
                      _vm.costs &&
                      Object.keys(_vm.costs).length > 0 &&
                      _vm.activeAccount != null
                        ? _c("CostsAccountGraph", {
                            key: "" + _vm.id + _vm.activeAccount,
                            attrs: {
                              costs: _vm.costs,
                              name: _vm.CostsAccount,
                              activeType: _vm.activeType,
                              activeAccount: _vm.activeAccount
                            },
                            on: { "update-date": _vm.handleDateUpdate }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.displayBoards.length > 0 && _vm.activeType === "group"
                    ? _c("div", [
                        _c("div", { staticClass: "card p-3 shadow-sm" }, [
                          _c(
                            "dl",
                            { staticClass: "m-0" },
                            [
                              _vm._l(_vm.displayBoards, function(contract) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: contract.contract,
                                      staticClass:
                                        "contracts py-2 px-3 border-bottom",
                                      class: [
                                        {
                                          "hover-contract":
                                            _vm.hoverContract ===
                                            contract.contract
                                        },
                                        {
                                          "inactive-contract":
                                            _vm.hoverContract !==
                                            contract.contract
                                        }
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.hoverContract = contract.contract
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverContract = null
                                        },
                                        click: function($event) {
                                          return _vm.updateContract(
                                            contract.contract
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(contract.contract) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    {
                                      key: contract.contract + "-details",
                                      staticClass: "contract-details px-3 py-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v("Monthly Cost:")
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                "$" + contract.cost.toFixed(2)
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center mt-1"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("Historical Change:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: _vm.changeClass(
                                                contract.historical_percentage_change
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.formatPercentage(
                                                      contract.historical_percentage_change
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center mt-1"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("Predicted Change:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: _vm.changeClass(
                                                contract.predicted_change
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.formatPercentage(
                                                      contract.predicted_change
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.displayAccounts.length > 0 &&
                  _vm.activeType === "contract"
                    ? _c("div", [
                        _c("div", { staticClass: "card p-3 shadow-sm" }, [
                          _c(
                            "dl",
                            { staticClass: "m-0" },
                            [
                              _vm._l(_vm.displayAccounts, function(account) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: account.account,
                                      staticClass:
                                        "members-list py-2 px-3 border-bottom",
                                      class: _vm.accountClass(account),
                                      on: {
                                        click: function($event) {
                                          return _vm.setActiveAccount(
                                            account.account
                                          )
                                        },
                                        mouseover: function($event) {
                                          _vm.hoverAccount = account.account
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverAccount = null
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(account.account) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    {
                                      key: account.account + "-details",
                                      staticClass: "contract-details px-3 py-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v("Monthly Cost:")
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                "$" + account.cost.toFixed(2)
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center mt-1"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("Historical Change:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: _vm.changeClass(
                                                account.historical_percentage_change
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.formatPercentage(
                                                      account.historical_percentage_change
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center mt-1"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("Predicted Change:")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: _vm.changeClass(
                                                account.predicted_change
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.formatPercentage(
                                                      account.predicted_change
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "transition",
              { attrs: { name: "fade", appear: "" } },
              [
                _vm.costs &&
                Object.keys(_vm.costs).length > 0 &&
                _vm.activeAccount != null
                  ? _c("vue-good-table", {
                      key: "" + _vm.id + _vm.activeAccount + _vm.date,
                      attrs: {
                        columns: _vm.columns,
                        rows: _vm.formattedCosts,
                        "search-options": {
                          enabled: true,
                          skipDiacritics: true,
                          placeholder: "Filter"
                        },
                        "pagination-options": { enabled: true, perPage: 20 },
                        styleClass: "vgt-table condensed"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-446a7d7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446a7d7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Costs.vue
// module id = null
// module chunks = 